const renderSvgLink = (isDarkMode) =>
  function ({ link, ...restProps }) {
    return <line strokeWidth=".5" stroke={isDarkMode ? "white" : "black"} {...restProps} />;
  };

export default renderSvgLink;
